import React from 'react'
import { MissingPageStyle } from './MissingPage.style'

const MissingPage = () => {
  return (
    <MissingPageStyle>
        <div className='body'>
          <h1 className='text-notfound'>404 Page Not found</h1>   
          <img src={"/ocufii_rev_mark.png"} className='img-logo' alt="Ocufii" />
          <h1 className='description'>Bringing smart innovation to the firearms industry !</h1>
        
        </div>
    </MissingPageStyle>
  )
}

export default MissingPage